import type { Locale, Price } from '~/utils/common';

import type { Address, ShippingMethod } from '../address/types';

export enum CartActionType {
  ADD_COUPON = 'add_coupon',
  ADD_ITEM = 'add_item',
  CHANGE_QTY = 'change_qty',
  REMOVE_COUPON = 'remove_coupon',
  REMOVE_ITEM = 'remove_item',
  SET_SHIPPING_METHOD = 'set_shipping_method',
  UPDATE_ADDRESS = 'update_address',
}

export interface BaseCartAction {
  type: CartActionType;
}

export interface Cart {
  billing_address?: Address;
  id: string;
  items: CartItem[];
  original_price: Price;
  shipping_address?: Address;
  shipping_amount?: Price;
  shipping_method?: ShippingMethod;
  subtotal: Price;
  total_discount?: Price;
  total_price: Price;
  total_tax?: Price;
}

export type CartAction =
  | CartActionAddCoupon
  | CartActionAddItem
  | CartActionChangeQty
  | CartActionRemoveCoupon
  | CartActionRemoveItem
  | CartActionSetShippingMethod
  | CartActionUpdateAddress;

export interface CartActionAddCoupon extends BaseCartAction {
  code: string;
  type: CartActionType.ADD_COUPON;
}

export interface CartActionAddItem extends BaseCartAction {
  quantity: number;
  sku: string;
  type: CartActionType.ADD_ITEM;
}

export interface CartActionChangeQty extends BaseCartAction {
  id: string;
  quantity: number;
  type: CartActionType.CHANGE_QTY;
}

export interface CartActionRemoveCoupon extends BaseCartAction {
  id: string;
  type: CartActionType.REMOVE_COUPON;
}
export interface CartActionRemoveItem extends BaseCartAction {
  id: string;
  type: CartActionType.REMOVE_ITEM;
}

export interface CartActionSetShippingMethod extends BaseCartAction {
  id: string;
  type: CartActionType.SET_SHIPPING_METHOD;
}

export interface CartActionUpdateAddress extends BaseCartAction {
  address: Address;
  address_type: AddressType;
  type: CartActionType.UPDATE_ADDRESS;
}

export interface CartItem {
  id: string;
  image_url?: string;
  last_modified_at: string;
  name: string;
  price: Price;
  quantity: number;
  sku: string;
  slug: string;
  total_price: Price;
}

export interface CartRequest {
  actions: CartAction[];
  country: string;
  id?: string;
  locale: Locale;
}
